// Determine the host based on environment
const getHost = () => {
    // In production, use the current domain without port
    if (process.env.REACT_APP_BUILD_MODE === "production" ) {
        return window.location.protocol + '//' + window.location.hostname;
    }
    
    // In development/staging, add port 1235 if not already present
    const currentPort = window.location.port;
    if (currentPort && currentPort !== "80" && currentPort !== "443") {
        // If already has a port (like 3000 for React dev server), use backend port
        return window.location.protocol + '//' + window.location.hostname + ":1240";
    }
    
    // Default case
    return window.location.protocol + '//' + window.location.hostname + ":1240";
}

const HOST = getHost();

// Get build mode from environment variable, fallback to development
export const BUILD_MODE = process.env.REACT_APP_BUILD_MODE || 'development';

const getConfig = () => {
    switch (BUILD_MODE) {
        case "production":
            return {
                CLIENT_ID: "1749620531449",
                AUTH_SERVER: "https://cpass.core1corp.com"
            }
        case "staging":
            return {
                CLIENT_ID: "1749620531449",
                AUTH_SERVER: "http://54.179.245.7:1234"
            }
    
        default:
            return {
                CLIENT_ID: "1749620531449",
                AUTH_SERVER: "http://54.179.245.7:1234"
            }
    }
}


export const MAX_USER_RETRIEVE = 15


export const CLIENT_ID = getConfig()!.CLIENT_ID;
export const AUTH_SERVER = getConfig()!.AUTH_SERVER;
export const REDIRECT_PATH = '/auth/callback';


// Authentication endpoints
export const ENDPOINT_AUTH_REQUEST = HOST + '/v1/auth/req'
export const ENDPOINT_LOGOUT = HOST + '/v1/logout'
export const ENDPOINT_SESSION = HOST + '/v1/session'

// users
export const ENDPOINT_USERS = HOST + '/v1/users'
export const ENDPOINT_USERS_CASA = HOST + "/v1/users/casa"
export const ENDPOINT_USERS_TD = HOST + "/v1/users/td"
export const ENDPOINT_USERS_SCA = HOST + "/v1/users/sca"
export const ENDPOINT_USERS_LOAN = HOST + "/v1/users/loan"
export const ENDPOINT_USERS_DEVICES = HOST + "/v1/users/devices"
export const ENDPOINT_USERS_DEVICE_REMOVE = HOST + "/v1/users/device/remove"
export const ENDPOINT_USERS_DEVICE_STATUS = HOST + "/v1/users/device/status"
export const ENDPOINT_USERS_DELETE = HOST + "/v1/users/delete"
export const ENDPOINT_USERS_BLOCK = HOST + "/v1/users/block"
export const ENDPOINT_USERS_UNBLOCK = HOST + "/v1/users/unblock"
export const ENDPOINT_USER_TRANSACTIONS = HOST + "/v1/users/transactions"

// company settings
export const ENDPOINT_COMPANY_SETTINGS = HOST + "/v1/company/settings"
export const ENDPOINT_COMPANY_SETTINGS_UPDATE = HOST + "/v1/company/settings/update"
export const ENDPOINT_COMPANY_SETTINGS_SECTION = HOST + "/v1/company/settings/section"
export const ENDPOINT_COMPANY_SETTINGS_SECTION_UPDATE = HOST + "/v1/company/settings/section/update"
export const ENDPOINT_COMPANY_SETTINGS_VALIDATE = HOST + "/v1/company/settings/validate"
export const ENDPOINT_COMPANY_SETTINGS_AUDIT = HOST + "/v1/company/settings/audit"
export const ENDPOINT_COMPANY_SETTINGS_TEST_HOST = HOST + "/v1/company/settings/test-host"
export const ENDPOINT_COMPANY_SETTINGS_TEST_AUTH = HOST + "/v1/company/settings/test-auth"

// themes
export const ENPOINT_THEMES = HOST + '/v1/themes'
export const ENDPOINT_THEME_UPDATE = HOST + "/v1/theme/update"
export const ENDPOINT_THEME_DELETE= HOST + "/v1/theme/delete"
export const ENDPOINT_THEME_CREATE= HOST + "/v1/theme/create"
export const ENDPOINT_THEME_DEFAULT= HOST + "/v1/theme/default"
export const ENDPOINT_THEME_UPDATE_IMAGE = HOST + "/v1/theme/update_image"

// landing
export const ENDPOINT_LANDING = HOST + "/v1/landing"
export const ENDPOINT_LANDING_UPDATE = HOST + "/v1/landing/update"
export const ENDPOINT_LANDING_UPDATE_IMAGE = HOST + "/v1/landing/update-image"

// home
export const ENDPOINT_HOME = HOST + "/v1/homed"
export const ENDPOINT_HOME_UPDATE = HOST + "/v1/homed/update"
export const ENDPOINT_HOME_UPDATE_IMAGE = HOST + "/v1/homed/update-image"

// support
export const ENDPOINT_SUPPORT = HOST + "/v1/support"
export const ENDPOINT_SUPPORT_UPDATE = HOST + "/v1/support/update"

// features
export const ENDPOINT_FEATURES = HOST + "/v1/features"
export const ENDPOINT_FEATURES_UPDATE = HOST + "/v1/features/update"

// templates
export const ENDPOINT_TEMPLATE_EMAIL =HOST + "/v1/emailtemp"
export const ENDPOINT_TEMPLATE_EMAIL_UPDATE =HOST + "/v1/emailtemp/update"
export const ENDPOINT_TEMPLATE_SMS = HOST  +"/v1/smstemp"
export const ENDPOINT_TEMPLATE_SMS_UPDATE = HOST + "/v1/smstemp/update"
export const ENDPOINT_TEMPLATE_SMS_PARAMS = HOST + "/v1/smstemp/params"
export const ENDPOINT_TEMPLATE_EMAIL_PARAMS = HOST + "/v1/emailtemp/params"
export const ENDPOINT_MSG_SETUP = HOST +"/v1/smstemp/setup"
export const ENDPOINT_MSG_SETUP_UPDATE = HOST +"/v1/smstemp/setup/post"
export const ENDPOINT_TEMPLATE_SMS_ADD = HOST +"/v1/smstemp/add"
export const ENDPOINT_TEMPLATE_EMAIL_ADD = HOST +"/v1/emailtemp/add"
export const ENDPOINT_TEMPLATE_SMS_RM = HOST +"/v1/smstemp/del"
export const ENDPOINT_TEMPLATE_EMAIL_RM = HOST +"/v1/emailtemp/del"

// storage
export const ENDPOINT_STORAGE_TEMP_UPLOAD = HOST + "/v1/storage/temp-upload"
export const ENDPOINT_STORAGE_MARK_USED = HOST + "/v1/storage/mark-used"

// charging
export const ENDPOINT_CHARGING = HOST + "/v1/charging"
export const ENDPOINT_CHARGING_UPDATE = HOST + "/v1/charging/update"
export const ENDPOINT_CHARGING_TRANSACTION_TYPES = HOST + "/v1/charging/transaction-types"
export const ENDPOINT_CHARGING_RANGES_ADD = HOST + "/v1/charging/ranges/add"
export const ENDPOINT_CHARGING_RANGES_DELETE = HOST + "/v1/charging/ranges/delete"
export const ENDPOINT_CHARGING_CALCULATE = HOST + "/v1/charging/calculate"